import { useCallback, useSyncExternalStore } from "react";

const STORAGE_KEY = "coloca:balances-hidden";
const listeners = new Set<() => void>();

function readStored(): boolean {
  try {
    return localStorage.getItem(STORAGE_KEY) === "1";
  } catch {
    return false;
  }
}

let hidden = readStored();

function notify() {
  listeners.forEach((listener) => listener());
}

function onStorage(event: StorageEvent) {
  if (event.key !== STORAGE_KEY) return;
  hidden = readStored();
  notify();
}

function subscribe(listener: () => void) {
  listeners.add(listener);
  if (listeners.size === 1) window.addEventListener("storage", onStorage);
  return () => {
    listeners.delete(listener);
    if (listeners.size === 0) window.removeEventListener("storage", onStorage);
  };
}

function setBalancesHidden(next: boolean) {
  hidden = next;
  try {
    localStorage.setItem(STORAGE_KEY, next ? "1" : "0");
  } catch {
    // Without storage the choice still holds until the tab is reloaded.
  }
  notify();
}

/** One choice for every balance on screen, remembered per browser. */
export function useBalancesHidden() {
  const value = useSyncExternalStore(
    subscribe,
    () => hidden,
    () => false,
  );
  const toggle = useCallback(() => setBalancesHidden(!hidden), []);
  return { hidden: value, toggle };
}
